import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  Grid,
  Snackbar,
  Alert,
} from "@mui/material";
import CustomGlowButton from "./GlowingButton";
import axios from "axios";
import { useLocation } from "react-router-dom";

// Simplified styles with glow effect
const borderStyles = {
  border: "0.92px solid",
  borderImageSource:
    "radial-gradient(80.38% 222.5% at -13.75% -12.36%, #98F9FF 0%, rgba(255, 255, 255, 0) 100%), radial-gradient(80.69% 208.78% at 108.28% 112.58%, #EABFFF 0%, rgba(135, 38, 183, 0) 100%)",
};
const styles = {
  container: {
    //borderRadius: "12px",
    // background: 'radial-gradient(90.16% 143.01% at 15.32% 21.04%, rgba(165, 239, 255, 0.2) 0%, rgba(110, 191, 244, 0.0447917) 77.08%, rgba(70, 144, 213, 0) 100%)',
    background:
      "radial-gradient(90.16% 143.01% at 15.32% 21.04%, rgba(165, 239, 255, 0.2) 0%, rgba(110, 191, 244, 0.05) 77.08%, rgba(70, 144, 213, 0.1) 100%)",
    ...borderStyles,
    //borderRadius: theme.spacing(2),
    backdropFilter: "blur(10px)",
    //backdropFilter: "blur(1px)",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
    //border: "1px solid rgba(140, 140, 194, 0.3)",
    width: "100%",
    maxWidth: "100%",
    padding: { xs: 3, md: 8 },
    borderWidth: "2px",
    borderStyle: "solid",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "start",
    margin: "0 auto",
    border: "0.64px solid transparent",
    borderRadius: "20px",
  },
  title: {
    color: "#FFFFFF",
    fontSize: "40px",
    fontWeight: 700,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  label: {
    color: "#a9a9df",
    marginBottom: "0.5rem",
  },
  input: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "rgba(45, 46, 86, 0.5)",
      color: "white",
      borderRadius: "6px",
      transition: "box-shadow 0.3s ease-in-out",
      "& fieldset": {
        borderColor: "#3d3e74",
      },
      "&:hover fieldset": {
        borderColor: "#8C8CC2",
      },
      "&.Mui-focused": {
        boxShadow: "0 0 10px rgba(140, 140, 194, 0.7)",
        "& fieldset": {
          borderColor: "#8C8CC2",
        },
      },
    },
    "& input:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px rgba(255,255,255,0.03) inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff",
      borderRadius: "12px",
      transition: "background-color 5000s ease-in-out 0s",
    },

    "& input:-webkit-autofill:hover": {
      WebkitBoxShadow: "0 0 0 100px rgba(255,255,255,0.03) inset",
      WebkitTextFillColor: "#fff",
    },

    "& input:-webkit-autofill:focus": {
      WebkitBoxShadow: "0 0 0 100px rgba(255,255,255,0.03) inset",
      WebkitTextFillColor: "#fff",
    },
  },
  select: {
    backgroundColor: "rgba(45, 46, 86, 0.5)",
    color: "white",
    borderRadius: "6px",
    transition: "box-shadow 0.3s ease-in-out",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#3d3e74",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#8C8CC2",
    },
    "&.Mui-focused": {
      boxShadow: "0 0 10px rgba(140, 140, 194, 0.7)",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#8C8CC2",
      },
    },
    "& .MuiSvgIcon-root": {
      color: "white",
    },
  },
  radio: {
    color: "#8C8CC2",
    "&.Mui-checked": {
      color: "#8C8CC2",
    },
  },
};

// Dropdown options
const COUNTRIES = [
  { value: "India", label: "India" },
  { value: "United States", label: "United States" },
  { value: "Canada", label: "Canada" },
  { value: "United Kingdom", label: "United Kingdom" },
  { value: "Australia", label: "Australia" },
  { value: "Germany", label: "Germany" },
  { value: "France", label: "France" },
  { value: "Japan", label: "Japan" },
  { value: "Brazil", label: "Brazil" },
  { value: "Mexico", label: "Mexico" },
];

const INTERESTS = [
  { value: "Request Demo", label: "Request Demo" },
  { value: "Product Information", label: "Product Information" },
  { value: "Pricing", label: "Pricing" },
  { value: "Technical Support", label: "Technical Support" },
];

const ProductList = [
  { value: "VISVA", label: "VISVA" },
  { value: "AURORA", label: "AURORA" },
  { value: "ICEBERG", label: "ICEBERG" },
  { value: "ONE", label: "ONE" },
  { value: "AVALANCHE", label: "AVALANCHE" },
];

const solutionlist = [
  { value: "AI Video Intelligence", label: "AI Video Intelligence" },
  { value: "Workforce & Safety Intelligence", label: "Workforce & Safety Intelligence" },
  { value: "Operational Risk Management", label: "Operational Risk Management" },
  { value: "ESG & Sustainability", label: "ESG & Sustainability" },
  { value: "Industrial Data Integration", label: "Industrial Data Integration" },
  { value: "Enterprise Compliance & Governance", label: "Enterprise Compliance & Governance" },
  { value: "AI Copilots & Autonomous Agents", label: "AI Copilots & Autonomous Agents" },
];



const INDUSTRIES = [
  {
    value: "Oil & Gas",
    label: "Oil & Gas",
  },
  {
    value: "Power & Renewable",
    label: "Power & Renewable",
  },
  {
    value: "Mining & Metal",
    label: "Mining & Metal",
  },
  {
    value: "Engineering & Construction",
    label: "Engineering & Construction",
  },
  {
    value: "Health & Pharma",
    label: "Health & Pharma",
  },
  {
    value: "Food Processing Industry",
    label: "Food Processing Industry",
  },
  {
    value: "Other",
    label: "Other",
  },
];

export default function ContactForm() {
  const location = useLocation();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    organization: "",
    position: "",
    country: "India",
    phone: "",
    industry: "Technology",
    interest: "Request Demo",
    category: "Product",
    message: "",
    suitCode: "",
  });



  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    const email = queryParams.get("email") || "";
    const fullName = queryParams.get("name") || "";
    const suitCode = queryParams.get("suitCode") || "";

    setFormData((prev) => ({
      ...prev,
      email,
      fullName,
      suitCode,
    }));
  }, [location?.search]);


  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        name: formData?.fullName,
        email: formData?.email,
        phone: formData?.phone,
        organizationName: formData?.organization,
        message: formData?.message,
        position: formData?.position,
        country: formData?.country,
        industry: formData?.industry,
        interest: formData?.interest,
        category: formData?.category,
        entity: formData?.entity
      };
      if (formData?.suitCode) {
        payload.suitCode = formData?.suitCode;
      }
      const result = await axios.post(
        "https://dev.ienergydigital.com/task-api/api/email-suits/book-demo",
        payload
      );

      if (result.data?.success) {
        setSnackbar({
          open: true,
          message:
            "Your demo request has been submitted successfully. Our team will contact you shortly.",
          severity: "success",
        });
      }

      setFormData({
        fullName: "",
        email: "",
        phone: "",
        organization: "",
        message: "",
        country: "",
        industry: "",
        interest: "",
        category: "",
        position: "",
        entity: ""
      });

    } catch (error) {
      console.log(error);
      setSnackbar({
        open: true,
        message:
          error?.response?.data?.message ||
          "Something went wrong. Please try again later.",
        severity: "error",
      });
    }
  };

  return (
    <>
      <Box sx={styles.container}>
        <Typography sx={styles.title}>Get in touch with us</Typography>
        <Typography sx={styles.title} marginBottom={4}>We're here to assist you</Typography>

        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {/* Name and Email */}
            <Grid item xs={12} md={6}>
              <Typography sx={styles.label}>Full Name *</Typography>
              <TextField
                fullWidth
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
                placeholder="John Doe"
                sx={styles.input}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography sx={styles.label}>Email *</Typography>
              <TextField
                fullWidth
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="john@example.com"
                sx={styles.input}
              />
            </Grid>

            {/* Organization and Position */}
            <Grid item xs={12} md={6}>
              <Typography sx={styles.label}>Organization</Typography>
              <TextField
                fullWidth
                name="organization"
                value={formData.organization}
                onChange={handleChange}
                placeholder="Your Company Name"
                sx={styles.input}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography sx={styles.label}>Position</Typography>
              <TextField
                fullWidth
                name="position"
                value={formData.position}
                onChange={handleChange}
                placeholder="Product Manager"
                sx={styles.input}
              />
            </Grid>

            {/* Country and Phone */}
            <Grid item xs={12} md={6}>
              <Typography sx={styles.label}>Country</Typography>
              <FormControl fullWidth>
                <Select
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  sx={styles.select}
                >
                  {COUNTRIES.map((country) => (
                    <MenuItem key={country.value} value={country.value}>
                      {country.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography sx={styles.label}>Phone Number</Typography>
              <TextField
                fullWidth
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="(555) 123-4567"
                sx={styles.input}
              />
            </Grid>

            {/* Industry and Interest */}
            <Grid item xs={12} md={6}>
              <Typography sx={styles.label}>Industry</Typography>
              <FormControl fullWidth>
                <Select
                  name="industry"
                  value={formData.industry}
                  onChange={handleChange}
                  sx={styles.select}
                >
                  {INDUSTRIES.map((industry) => (
                    <MenuItem key={industry.value} value={industry.value}>
                      {industry.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography sx={styles.label}>Interest</Typography>
              <FormControl fullWidth>
                <Select
                  name="interest"
                  value={formData.interest}
                  onChange={handleChange}
                  sx={styles.select}
                >
                  {INTERESTS.map((interest) => (
                    <MenuItem key={interest.value} value={interest.value}>
                      {interest.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Category */}
            <Grid item xs={6}>
              <Typography sx={styles.label}>Category</Typography>
              <RadioGroup
                name="category"
                value={formData.category}
                onChange={handleChange}
                row
              >
                <FormControlLabel
                  value="Product"
                  control={<Radio sx={styles.radio} />}
                  label="Product"
                  sx={{ color: "white" }}
                />
                <FormControlLabel
                  value="Solution"
                  control={<Radio sx={styles.radio} />}
                  label="Solution"
                  sx={{ color: "white" }}
                />
                <FormControlLabel
                  value="Industry"
                  control={<Radio sx={styles.radio} />}
                  label="Industry"
                  sx={{ color: "white" }}
                />
              </RadioGroup>
            </Grid>
            {formData?.category &&
              <Grid item xs={12} md={6}>
                <Typography sx={styles.label}>Product Name</Typography>
                <FormControl fullWidth>
                  <Select
                    name="entity"
                    value={formData?.entity}
                    onChange={handleChange}
                    sx={styles.select}
                  >
                    {
                      (
                        formData?.category === "Product"
                          ? ProductList
                          : formData?.category === "Solution"
                            ? solutionlist
                            : INDUSTRIES
                      )?.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Grid>
            }

            {/* Message */}
            <Grid item xs={12}>
              <Typography sx={styles.label}>Message</Typography>
              <TextField
                fullWidth
                name="message"
                value={formData?.message}
                onChange={handleChange}
                multiline
                rows={4}
                placeholder="How can we help you?"
                sx={styles.input}
              />
            </Grid>

            {/* Submit Button */}
          </Grid>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            marginTop: 4,
          }}
        >
          <Box onClick={handleSubmit}>
            <CustomGlowButton text={`Leave us a Message!`} />
          </Box>
        </Box>


      </Box>

      <Snackbar
        open={snackbar?.open}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar?.severity}
          variant="filled"
          sx={{
            width: "100%",
            borderRadius: "12px",
            fontWeight: 600,
            fontSize: "14px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
          }}
        >
          {snackbar?.message}
        </Alert>
      </Snackbar>
    </>
  );
}
